import type { ReactNode } from 'react';
import classNames from '../../../utils/classNames';

interface Props {
    children: ReactNode;
    className?: string;
}

export function GraphToolbarGroup({ children, className = '' }: Props): JSX.Element {
    return <span className={classNames('inline-flex gap-0.5', className)}>{children}</span>;
}
